import { SearchOrigin } from '@app/search/services/search-tracker.service';
import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { SearchService } from '@app/search/services/search.service';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { Observable, EMPTY } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { NUM_TILE_RESULTS_PER_PAGE } from '@app/shared/search.token';
import { SearchSuggestionSource } from '@app/search/search-api.model';
import { TagsService } from '@app/tags/services/tags.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchFlagsService } from '@app/search/services';

@Component({
  selector: 'dgx-search-skills-view',
  templateUrl: './search-skills-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSkillsViewComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  public data: Observable<any>;
  public hasError = false;
  public searchOrigin = SearchOrigin.skills;
  public suggestionSource = SearchSuggestionSource.AutoSuggestSkills;
  public i18n = this.translateService.instant(['Core_Skills']);

  private searchData: { term: string; numResultsToSkip: number } = {
    term: '',
    numResultsToSkip: 0,
  };

  constructor(
    private searchService: SearchService,
    private tagsService: TagsService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private searchFlagsService: SearchFlagsService,
    @Inject(NUM_TILE_RESULTS_PER_PAGE)
    private readonly numResultsPerPage: number
  ) {
    super();
  }

  public get showSearchTabs(): boolean {
    return this.searchFlagsService.showSearchLayoutRedesign;
  }

  public ngOnInit(): void {
    this.tagsService.userTagsModified
      .pipe(this.takeUntilDestroyed())
      .subscribe(() => {
        this.cdr.markForCheck();
        this.search(this.searchData);
      });
  }

  public search({ term, numResultsToSkip }) {
    this.searchData = { term, numResultsToSkip };
    this.data = this.searchService
      .skillsSearchFull(term, this.numResultsPerPage, numResultsToSkip)
      .pipe(
        share(),
        catchError(() => {
          this.hasError = true;
          this.cdr.markForCheck();
          // Return EMPTY here rather than of(null); EMPTY
          // is a "never" stream, perfect for when we want
          // to end the stream by returning an Observable
          // with no content.
          return EMPTY;
        })
      );
  }
}
